import classNames from 'classnames';
import html2canvas from 'html2canvas';
import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

import copyImage from '../../utils/copyImage';
import copyText from '../../utils/copyText';

function ClipboardCopy({ data, mode = 'csv', className }) {
  const [isCopyAlertDisplayed, setCopyAlertVisibility] = useState(false);

  function copy() {
    if (mode === 'csv') {
      let rawData = data.map((ele) => Object.values(ele).join('\t'));

      if (data.length > 0) rawData.unshift(Object.keys(data[0]).join('\t'));

      copyText(rawData.join('\n'));
    } else {
      html2canvas(document.querySelector('#graph_0')).then((canvas) => {
        canvas.style.removeProperty('width');
        canvas.style.removeProperty('height');
        const url = canvas.toDataURL('image/png');
        copyImage(url);
      });
    }
    setCopyAlertVisibility(true);
    setTimeout(() => {
      setCopyAlertVisibility(false);
    }, 500);
  }

  return (
    <div className="relative">
      {isCopyAlertDisplayed && (
        <Alert variant="success">
          <Alert.Heading> Copied to Clipboard </Alert.Heading>
        </Alert>
      )}

      <i
        className={classNames(
          'fas fa-clipboard fa-2x cursor-pointer text-white',
          className,
        )}
        title={mode === 'csv' ? 'copy csv' : 'copy chart'}
        onClick={copy}
      />
    </div>
  );
}

export default ClipboardCopy;
